import { getDataWithArray } from "./helpers/formDataArr";
import { postData } from "./helpers/postData";
import { removeErrors } from "./helpers/removeErrors";
import { getIntlTelInput } from "./intl-tel-input/intl-mask";
import { openModal, setModalContent } from "./modal";

const teacherForm = document.querySelector('[data-form="teacher-poll"]');

if (teacherForm) {
    const btn = teacherForm.querySelector(".btn-site");
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');

    let selectedCheckboxes = "";
    let rules = "";

    if (checkboxes) {
        checkboxes.forEach(check => {
            check.addEventListener("click", ({ target }) => {
                const value = target.value;

                if (target.hasAttribute("data-rules")) {
                    if (target.checked) {
                        rules = true;
                    } else {
                        rules = false;
                    }
                } else {
                    if (target.checked) {
                        if (selectedCheckboxes) {
                            selectedCheckboxes += `,${value}`;
                        } else {
                            selectedCheckboxes = value;
                        }
                    } else {
                        if (selectedCheckboxes.includes(value)) {
                            selectedCheckboxes = selectedCheckboxes
                                .split(",")
                                .filter(item => item !== value)
                                .join(",");
                        } else {
                            selectedCheckboxes = "";
                        }
                    }
                }
            });
        });
    }

    teacherForm.addEventListener("submit", e => {
        e.preventDefault();
        const url = teacherForm.dataset.action;
        const fields = getDataWithArray(teacherForm);

        if (selectedCheckboxes === "off") {
            selectedCheckboxes = "";
        }

        let phoneNumber;
        const iti = getIntlTelInput();
        iti.forEach(iti => {
            const currentInput = iti.telInput;
            const currentInputData = currentInput.dataset.phone;
            if (currentInputData === "teacher") {
                phoneNumber = iti.getNumber();
            }
        });

        const data = {
            ...fields,
            phone: phoneNumber,
            directions: selectedCheckboxes ? selectedCheckboxes : "",
            rules: rules
        };

        btn.setAttribute("disabled", true);
        removeErrors();

        postData(url, data)
            .then(res => {
                if (res) {
                    if (res.status) {
                        const modal = document.querySelector(
                            '[data-modal="success"]'
                        );
                        const title = res.message;
                        openModal(modal);
                        setModalContent(modal, { title });
                        teacherForm.reset();
                    }

                    if (res.errors) {
                        for (const error in res.errors) {
                            const errorMessage = document.querySelector(
                                `[data-key="${error}"]`
                            );
                            errorMessage.innerHTML = "";
                            errorMessage.innerHTML = `${res.errors[error]}`;
                        }

                        if (Object.keys(res.errors).length > 0) {
                            btn.insertAdjacentHTML(
                                "beforebegin",
                                `<span class="error-message error-message--lg" data-error="base">Не заповнені обов'язкові поля!</span>`
                            );
                        }
                    }
                }
            })
            .catch(err => console.log(err))
            .finally(() => btn.removeAttribute("disabled"));
    });
}
